import { combineReducers } from 'redux';

// import all reducers

//licenze
import GetLoggedUser from './user/r_getLoggedUser';

//licenze
import GetLicenses from './licenze/r_getLicenses';
import FilterLicenses from './licenze/r_filterLicenses';

import SaveLicense from './licenze/r_saveLicense';

import EditDataScadenza from './licenze/r_editDataScadenzaLicense';
import ManageStateLicense from './licenze/r_manageStateLicense';
import UnlinkLicense from './licenze/r_unlinkLicense';


import ManageModuli from './licenze/r_manageModuli';
import SetCodiceModuli from './licenze/r_setCodiceModuli';
import InsertModuli from './licenze/r_insertModuli';
import SetSerialNumberOld from './licenze/r_setSerialNumberOld';

import GetLicenseDetails from './licenze/r_getLicenseDetails';

import EditLicense from './licenze/r_editLicense';


import GetCodiciUtente from './licenze/r_getCodiciUtente';
import CreateLicense from './licenze/r_createLicenseData';
import GenPK from './licenze/r_genPK';
import GenSN from './licenze/r_genSN';
import CheckSN from './licenze/r_checkSN';
import IsSerialOldUsed from './licenze/r_isSerialOldUsed';

import MultiViewGestioneLicenze from './licenze/r_multiViewGestioneLicenze';

//statistiche
import GetStatistiche from './statistiche/r_getStatistiche';

//log
import LogAccessi from './log/r_getLogAccessi';
import FilterLogAccessi from './log/r_filterLogAccessi';

import LogLicenze from './log/r_getLogLicenze';
import FilterLogLicenze from './log/r_filterLogLicenze';

//email
import SendLicenseDetails from './email/r_sendLicenseDetails';


export default combineReducers({
    // user
    [GetLoggedUser.store]: GetLoggedUser.reducer,

    // licenze
    [GetLicenses.store]: GetLicenses.reducer,

    [SaveLicense.store]: SaveLicense.reducer,

    [EditLicense.store]: EditLicense.reducer,


    [EditDataScadenza.store]: EditDataScadenza.reducer,
    [ManageStateLicense.store]: ManageStateLicense.reducer,
    [UnlinkLicense.store]: UnlinkLicense.reducer,

    [ManageModuli.store]: ManageModuli.reducer,
    [SetCodiceModuli.store]: SetCodiceModuli.reducer,
    [InsertModuli.store]: InsertModuli.reducer,
    [SetSerialNumberOld.store]: SetSerialNumberOld.reducer,

    // dati licenze
    [GetCodiciUtente.store]: GetCodiciUtente.reducer,
    [CreateLicense.store]: CreateLicense.reducer,
    [GenPK.store]: GenPK.reducer,
    [GenSN.store]: GenSN.reducer,
    [CheckSN.store]: CheckSN.reducer,
    [IsSerialOldUsed.store]: IsSerialOldUsed.reducer,

    [FilterLicenses.store]: FilterLicenses.reducer,
    [MultiViewGestioneLicenze.store]: MultiViewGestioneLicenze.reducer,

    [GetLicenseDetails.store]: GetLicenseDetails.reducer,

    //statistiche
    [GetStatistiche.store]: GetStatistiche.reducer,

    //log 
    [LogAccessi.store]: LogAccessi.reducer,
    [FilterLogAccessi.store]: FilterLogAccessi.reducer,

    [LogLicenze.store]: LogLicenze.reducer,
    [FilterLogLicenze.store]: FilterLogLicenze.reducer,

    //email
    [SendLicenseDetails.store]: SendLicenseDetails.reducer,
});

// export all reducers
export {
    // user
    GetLoggedUser,

    // licenze
    GetLicenses,

    SaveLicense,

    EditLicense,

    EditDataScadenza,
    ManageStateLicense,
    UnlinkLicense,

    ManageModuli,
    SetCodiceModuli,
    InsertModuli,
    SetSerialNumberOld,

    GetCodiciUtente,
    CreateLicense,
    GenPK,
    GenSN,
    CheckSN,
    IsSerialOldUsed,

    GetLicenseDetails,

    FilterLicenses,
    MultiViewGestioneLicenze,

    //statistiche
    GetStatistiche,

    //log
    LogAccessi,
    FilterLogAccessi,

    LogLicenze,
    FilterLogLicenze,

    //email
    SendLicenseDetails,
};
